import React, { Component } from 'react';
import Typography from 'material-ui/Typography';
import QueryService from './QueryService';
import Switch from 'material-ui/Switch';
import TextField from 'material-ui/TextField';
import debounce from 'lodash/debounce';

class SeasonsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            seasons: {},
            error: false,
        };
        this.new_season_label = React.createRef();
    }

    getServerState = () => {
        QueryService.get('/seasons')
        .then(json => {
            var season_map = {};
            json.data.forEach((season) => {
                season_map[season.id] = {label: season.attributes.label, active: season.attributes.active};
            });
            this.setState({seasons: season_map});
        })
        .catch(err => {
            console.log('cannot fetch seasons, could be redirection error due to not being logged in', err);
            this.setState({error: true});
        });
    }

    componentDidMount() {
        this.getServerState();
    }

    updateSingleSeason = debounce((season_id, season_map) => {
        QueryService.put('/seasons/' + season_id, season_map[season_id])
        .then(() => {this.getServerState()});
    }, 500);

    updateAttribute = (season_id, attribute, attributeField) => event => {
        const value = event.target[attributeField];
        var season_map = this.state.seasons;
        season_map[season_id][attribute] = value;
        this.setState({seasons: season_map});
        this.updateSingleSeason(season_id, season_map);
    }

    createNewSeason = event => {
        QueryService.post('/seasons/', {label: this.new_season_label.current.value, active: false})
        .then(() => {this.getServerState()});
    }

    render() {
        const {seasons, error} = this.state;
        if (! error) {
            return (
                <div>
                    <Typography variant="title">Seasons</Typography>
                    "Active" is the season shown for the fantasy section of the site.
                    <ul>
                    {Object.entries(seasons).map(([season_id, attribute_map]) =>
                        <li key={season_id}>
                            <TextField
                                label="Year"
                                value={attribute_map.label}
                                onChange={this.updateAttribute(season_id, 'label', 'value')}
                            />
                            active: 
                            <Switch
                                checked={attribute_map.active}
                                color="primary"
                                onChange={this.updateAttribute(season_id, 'active', 'checked')}
                            />
                        </li>
                    )}
                    </ul>
                    Create a New Season
                    <form onSubmit={this.createNewSeason}>
                        <label>Year</label>
                        <input type="text" ref={this.new_season_label}></input>
                        <input type="submit"></input>
                    </form>
                </div>
            );
        } else {
            return <div>Error!</div>;
        }
    }
}

export default SeasonsPage;


// WEBPACK FOOTER //
// ./src/Seasons.js